// 개발서버(dev.wmdpass.com · *.dev.wmdpass.com)에서만 화면 최상단에 얇은 빨간 DEV 표시를 붙인다.
// 도메인으로만 판단하므로 운영(wmdpass.com)에는 절대 나오지 않는다 — docs/deploy-environments.md
// 같은 코드가 STS·ChurchAdmin·Identity Admin·Docs 에 각각 있다(빌드가 달라 공유 불가). 바꾸면 함께 바꾼다.
import './devBanner.css';

const DEV_HOST = /(^|\.)dev\.wmdpass\.com$/i;

export function isDevSite(host) {
    const h = host ?? (typeof window !== 'undefined' ? window.location.hostname : '');
    return DEV_HOST.test(h);
}

export function mountDevBanner() {
    if (typeof document === 'undefined' || !isDevSite()) return;
    const mount = () => {
        if (document.getElementById('zc-dev-banner')) return;
        const bar = document.createElement('div');
        bar.id = 'zc-dev-banner';
        bar.className = 'zc-dev-banner';
        bar.setAttribute('aria-hidden', 'true');
        const tag = document.createElement('span');
        tag.textContent = 'DEV';
        bar.appendChild(tag);
        document.body.appendChild(bar);
    };
    if (document.body) mount();
    else document.addEventListener('DOMContentLoaded', mount, { once: true });
}
